import { useQuery } from '@tanstack/react-query';
import { getConfig } from '~/services/config.ts';
import axiosInstance from '~/services/axios.ts';
import { APIResponse } from '~/services/types';

export type ProfileTokenResponse = {
  active: boolean;
};

const getProfileWithToken = async <TData>(token: string) => {
  const config = getConfig();

  const { data } = await axiosInstance.get<APIResponse<TData>>(`${config.domains.auth}/auth/setup-profile`, {
    params: {
      token,
    },
  });
  return data;
};

export const useProfileToken = (token: string | null) => {
  return useQuery({
    queryFn: () => getProfileWithToken<ProfileTokenResponse>(token as string),
    queryKey: ['profile', token],
    enabled: !!token,
  });
};
